import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { Notification } from '../../../../common/notification'
import { selectCompanyInfo } from '../../../../companyAnalysis/common/header/companyInfo/store/slice'
import { DynamicReportTable } from '../../../../companyAnalysis/financial/financialStatements/dynamicReportTable'
import { getDataTransform } from '../../../../companyAnalysis/financial/financialStatements/store/thunk'
import EventEmitter, { SHOW_SETTING_FS } from '../../../../helpers/EventEmitter'
import { getUnique } from '../../../../helpers/common'
import {
  MAIN_SCREEN,
  SCREEN,
  TYPE_INFORMATION_PANEL,
  TYPE_ITEM_SETTING,
} from '../../constant'

export const getPanelListFinancialStatement = () => {
  return [
    {
      screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_STATEMENT,
      label: 'dynamicReport.FINANCIAL_STATEMENT',
      type: TYPE_ITEM_SETTING.PANEL,
      setting: { fsType: ['balanceSheets', 'incomeStatements', 'cashFlows'] },
    },
  ]
}

const SettingFs = () => {
  const companyInfo = useSelector(selectCompanyInfo)

  if (!companyInfo.organizationId) {
    return (
      <div className="dFlex alignItemsCenter mt1">
        <Icon className="icon-info-circle pr1" style={{ color: '#9C9C9C' }} />
        <Element elementName="span" style={{ color: '#9C9C9C' }}>
          <Translate value="dynamicReport.SETTING_FS_WARNING" />
        </Element>
      </div>
    )
  }

  return (
    <>
      <Translate value="dynamicReport.SETTING_FS_1" />
      <Element
        style={{ color: '#2C73E8' }}
        elementName="span"
        className="cursorPointer"
        onClick={() => EventEmitter.dispatch(SHOW_SETTING_FS, true)}
      >
        <Translate value="dynamicReport.SETTING_FS_2" />
      </Element>
      .
    </>
  )
}

const orderType = {
  balanceSheets: 1,
  incomeStatements: 2,
  cashFlows: 3,
}

export const getPanelFinancialStatement = (
  { fsType = [] },
  currencyUnitFs = [],
  { years },
) => {
  return {
    components: years
      ? currencyUnitFs.reduce((result, { currency, unit }) => {
          fsType
            .sort((type1, type2) => orderType[type1] - orderType[type2])
            .forEach((type) => {
              result.push(() => (
                <DynamicReportTable
                  fsType={type}
                  currency={currency}
                  unit={unit}
                />
              ))
            })
          return result
        }, [])
      : [() => <Notification isDynamicReport />],
    thunk: [
      ({ companyInfo, settingFs }) =>
        getDataTransform({
          organizationId: companyInfo.organizationId,
          ...settingFs,
        }),
    ],
    isWaitForMount: true,
    isTable: true,
    settingPanel: {
      items: [
        {
          type: TYPE_INFORMATION_PANEL.CHECKBOX,
          key: 'fsType',
          value: 'balanceSheets',
          title: 'dynamicReport.BALANCE_SHEET',
        },
        {
          type: TYPE_INFORMATION_PANEL.CHECKBOX,
          key: 'fsType',
          value: 'incomeStatements',
          title: 'dynamicReport.INCOME_STATEMENT',
        },
        {
          type: TYPE_INFORMATION_PANEL.CHECKBOX,
          key: 'fsType',
          value: 'cashFlows',
          title: 'dynamicReport.CASHFLOW_STATEMENT',
        },
        {
          type: TYPE_INFORMATION_PANEL.NODE,
          renderItem: () => <SettingFs />,
        },
      ],
    },
  }
}

export const getDefaultFinancialStatement = () => {
  return getPanelListFinancialStatement().map((panel) => ({
    id: getUnique(),
    ...panel,
    setting: {
      fsType: ['balanceSheets', 'incomeStatements', 'cashFlows'],
    },
  }))
}
